import { CountryEnv, LANGUAGE } from "@type/index";

const _countryEnv: CountryEnv = {
  clientId: process.env.REACT_APP_CLIENT_ID_MY_UQ || "uq.my.new-styling-book",
  sbRootId: process.env.REACT_APP_FILTERS_SB_ROOT_ID_MY_UQ || 27431,
  shRootId: process.env.REACT_APP_FILTERS_SH_ROOT_ID_MY_UQ || 27432,
  firebaseApiKey: process.env.REACT_APP_FIREBASE_API_KEY_MY_UQ || "",
  firebaseProjectId: process.env.REACT_APP_FIREBASE_PROJECT_ID_MY_UQ || "",
  firebaseAppId: process.env.REACT_APP_FIREBASE_APP_ID_MY_UQ || "",
  firebaseMeasurementId:
    process.env.REACT_APP_FIREBASE_MEASUREMENT_ID_MY_UQ || "",
  storeDomain: process.env.REACT_APP_STORE_DOMAIN_UQ || "",
  showAboutApp: true,
  showDualPrice: false,
  languages: [LANGUAGE.EN],
  countryRegion: "Asia/Kuala_Lumpur",
  timeZone: {
    [LANGUAGE.EN]: {
      defaultTimezone: "MYT",
      offset: {
        MYT: 8
      }
    }
  },
  dateFormat: {
    [LANGUAGE.EN]: "<dd>/<mm>/<yyyy>"
  },
  requireDecimal: false
};

export default _countryEnv;
